import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import CheckoutForm from "./components/CheckoutForm";
import "./App.css";
import PaymentStatus from "./components/PaymentStatus";

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/checkout-form" component={CheckoutForm} />
        <Route exact path="/payment-status" component={PaymentStatus} />
      </Switch>
    </Router>
  );
}

export default App;
